import React, { useState } from 'react';

export interface TileItem {
  key: string;
  label: string;
  icon: React.ReactNode;
  color: string;
}

interface TileContainerProps {
  tiles: TileItem[];
  onSelect: (key: string) => void;
  /** Optional column min-width in px (default 140) */
  columnMinWidth?: number;
  /** Optional gap between tiles in px (default 20) */
  gap?: number;
}

function Tile({ tile, onSelect, columnMinWidth }: { tile: TileItem; onSelect: (key: string) => void; columnMinWidth: number }) {
  const [hovered, setHovered] = useState(false);

  return (
    <button
      style={{
        ...s.tile,
        minWidth: columnMinWidth,
        boxShadow: hovered ? '0 8px 24px rgba(0,0,0,0.12)' : '0 2px 8px rgba(0,0,0,0.07)',
        transform: hovered ? 'translateY(-3px)' : 'translateY(0)',
      }}
      onClick={() => onSelect(tile.key)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      title={tile.label}
    >
      <div style={{ ...s.iconBox, background: tile.color }}>
        <span style={s.icon}>{tile.icon}</span>
      </div>
      <span style={s.label}>{tile.label}</span>
    </button>
  );
}

export default function TileContainer({ tiles, onSelect, columnMinWidth = 140, gap = 20 }: TileContainerProps) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, minmax(${columnMinWidth}px, 1fr))`,
        gap,
      }}
    >
      {tiles.map(tile => (
        <Tile key={tile.key} tile={tile} onSelect={onSelect} columnMinWidth={columnMinWidth} />
      ))}
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  tile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 14,
    padding: '28px 16px',
    background: '#fff',
    border: '1px solid #e2e8f0',
    borderRadius: 14,
    cursor: 'pointer',
    transition: 'transform 0.18s, box-shadow 0.18s',
  },
  iconBox: {
    width: 60,
    height: 60,
    borderRadius: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  icon: {
    fontSize: 26,
    color: '#fff',
    display: 'flex',
  },
  label: {
    fontSize: 13,
    fontWeight: 600,
    color: '#1e293b',
    textAlign: 'center',
  },
};
